import localDB from "./localDB";
let GLOBAL = require('./globals');

const DeliveryData = {
    async get(res) {
        await fetch(`${GLOBAL.BASE_URL}api/store-delivery`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(err));
    },
    async deliveryMen(res) {
        await fetch(`${GLOBAL.BASE_URL}api/delivery-men`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(err));
    },
    async update(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/store-delivery`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(err));
    },
    async updateDeliverySale(data, res) {
        let url = data.id ? `${GLOBAL.BASE_URL}api/delivery-sale/${data.id}`:`${GLOBAL.BASE_URL}api/my-deliveries`
        await fetch(url, {
            method: data.id ? 'PATCH':'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(err));
    },
    async deliveryManStatsToday(res) {
        await fetch(`${GLOBAL.BASE_URL}api/delivery-men-stats-today`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(err));
    },
};

export default DeliveryData;


// WEBPACK FOOTER //
// ./src/data/DeliveryData.js